import * as React from 'react';

import type { RateCollectionClient } from '@/api/rate-collection-client';
import { HttpRateCollectionClient } from '@/api/rate-collection-client.http';

// =============================================================================
// rate-collection-client-context.tsx — Injection du RateCollectionClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S12) : l'adaptateur HTTP
// RÉEL (HttpRateCollectionClient) — le BACK rate-collection fournisseur est livré (D1).
// Les tests de composant injectent un StubRateCollectionClient (double déterministe) via
// le provider ; l'E2E intégré (ST-SAISIE-02) exerce l'adaptateur réel via le proxy.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultRateCollectionClient: RateCollectionClient = new HttpRateCollectionClient();

const RateCollectionClientContext =
  React.createContext<RateCollectionClient>(defaultRateCollectionClient);

export interface RateCollectionClientProviderProps {
  client?: RateCollectionClient | undefined;
  children: React.ReactNode;
}

export function RateCollectionClientProvider({
  client = defaultRateCollectionClient,
  children,
}: RateCollectionClientProviderProps): React.JSX.Element {
  return (
    <RateCollectionClientContext.Provider value={client}>
      {children}
    </RateCollectionClientContext.Provider>
  );
}

export function useRateCollectionClient(): RateCollectionClient {
  return React.useContext(RateCollectionClientContext);
}
